import { FieldErrors, FieldValues } from 'react-hook-form';

const getFirstErrorFieldName = (errors: FieldErrors, prefix = ''): string | null => {
  for (const key of Object.keys(errors)) {
    const error = errors[key];

    if (!error || typeof error !== 'object') {
      continue;
    }

    const path = prefix ? `${prefix}.${key}` : key;

    if ('message' in error && typeof error.message === 'string' && error.message) {
      return path;
    }

    const nested = getFirstErrorFieldName(error as FieldErrors, path);

    if (nested) {
      return nested;
    }
  }

  return null;
};

const findFieldElement = (scope: ParentNode, fieldName: string): HTMLElement | null => {
  let el = scope.querySelector(`[data-rhf-field="${fieldName}"]`);

  if (!el && fieldName.includes('.')) {
    const lastSegment = fieldName.split('.').pop();

    if (lastSegment) {
      el = scope.querySelector(`[data-rhf-field="${lastSegment}"]`);
    }
  }

  if (!el) {
    el = scope.querySelector(`[name="${fieldName}"]`);
  }

  return el instanceof HTMLElement ? el : null;
};

export const scrollToFirstFormError = (errors: FieldErrors<FieldValues>, root?: ParentNode | null): boolean => {
  const fieldName = getFirstErrorFieldName(errors);

  if (!fieldName) {
    return false;
  }

  const scope = root ?? document;
  const el = findFieldElement(scope, fieldName);

  if (!el) {
    return false;
  }

  el.scrollIntoView({ behavior: 'smooth', block: 'center' });

  const focusTarget =
    el.querySelector<HTMLElement>('input:not([type="hidden"]), textarea, select, [role="combobox"]') ?? el;

  focusTarget.focus({ preventScroll: true });

  return true;
};

export const scrollToFirstFormErrorOnInvalid = (errors: FieldErrors<FieldValues>) => {
  const dialogForm = document.querySelector('.MuiDialog-root form');

  if (dialogForm && scrollToFirstFormError(errors, dialogForm)) {
    return;
  }

  scrollToFirstFormError(errors);
};
